import script from "./GalleryBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryBlock.vue?vue&type=script&setup=true&lang=js"

import "./GalleryBlock.vue?vue&type=style&index=0&id=0ca69d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca69d7e"]])

export default __exports__